// extracted by mini-css-extract-plugin
module.exports = {"CustomerLogo":"listOfContent-module--CustomerLogo--3jl7e","Link":"listOfContent-module--Link--3dESm"};